export function redirectToRequestAccessPage() {
  window.location.replace(
    window.argosConfiguration.accessRequestUrl + window.location.href,
  );
}
